<template>
    <div class="d-flex justify-content-between align-items-center me-4 ms-3 mb-3">
        <!-- Botón para cambiar entre vista de tarjetas y lista -->
        <!-- Campo de búsqueda -->
        <input v-model="search" placeholder="Buscar..." class="form-control w-50" @input="applyFilter" />

        <div class="col-sm-3 m-2 d-flex align-items-center">
            <button class="btn btn-link p-0 px-2 mt-3" @click.prevent="clearFilter">
                <i class="fa-solid fa-broom-wide fa-lg"></i>
            </button>
            <div class="flex-grow-1">
                <MenuSelectedFull
v-model="selectedFilterCategory" label="" apiurl="item-categories"
                    :can-edit-and-add="false" />
            </div>
        </div>


        <div class="col-sm-4">
            <select
id="choices-category-filter" v-model="selectedFilter" class="form-control"
                name="choices-category-filter" @change="applyFilter">
                <option v-for="option in orderOptions" :key="option.value" :value="option.value">{{ option.text }}
                </option>
            </select>
        </div>

        <!-- Select para número de elementos por página -->
        <select v-model.number="localItemsPerPage" class="form-select w-auto px-2 m-2" style="width: 60px !important;">
            <option value="6">6</option>
            <option value="9">9</option>
            <option value="30">30</option>
            <option value="50">50</option>
        </select>

    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue';
import MenuSelectedFull from "@/components/MenuSelectedFull.vue";

// Define los eventos emitidos por el componente
const emit = defineEmits(['applyFilter', 'updateItemsPerPage', 'updateViewAsCard', 'updateShowDeleted']);

// Define las propiedades recibidas por el componente
const props = defineProps({
    orderOptions: {
        type: Array,
        required: true
    },
    itemsPerPage: {
        type: Number,
        required: true
    },
    showDeleted: {
        type: Boolean,
        required: true
    }
});

// Variables reactivas para el estado del componente
const search = ref('');
const selectedFilter = ref('bestseller');
const selectedFilterCategory = ref('');
const localItemsPerPage = ref(props.itemsPerPage);

const clearFilter = () => {
    selectedFilterCategory.value = null;
    applyFilter();
};

// Función para aplicar el filtro de búsqueda y categoría
const applyFilter = () => {
    emit('applyFilter',
        {
            search: search.value,
            selectedFilter: selectedFilter.value,
            filters: {
                category_id: selectedFilterCategory.value
            }
        });
};

// Observa cambios en selectedFilterCategory y llama a applyFilter
watch(selectedFilterCategory, () => {
    applyFilter();
});

// Función para actualizar el número de elementos por página
const updateItemsPerPage = () => {
    emit('updateItemsPerPage', localItemsPerPage.value);
};

// Observa cambios en props.itemsPerPage y actualiza localItemsPerPage
watch(() => props.itemsPerPage, (newItemsPerPage) => {
    localItemsPerPage.value = newItemsPerPage;
});

// Observa cambios en localItemsPerPage y emite el evento correspondiente
watch(localItemsPerPage, () => {
    updateItemsPerPage();
});

</script>
